var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProtection({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_56_1391)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.044 4.26816L16 1.8335L26.956 4.26816C27.2521 4.33398 27.5169 4.49878 27.7067 4.73537C27.8965 4.97196 27.9999 5.26618 28 5.5695V18.8855C27.9999 20.2025 27.6747 21.4991 27.0532 22.6602C26.4317 23.8213 25.5332 24.811 24.4373 25.5415L16 31.1668L7.56267 25.5415C6.46703 24.8111 5.56861 23.8216 4.94713 22.6608C4.32565 21.4999 4.00032 20.2036 4 18.8868V5.5695C4.00005 5.26618 4.10352 4.97196 4.29332 4.73537C4.48312 4.49878 4.74792 4.33398 5.044 4.26816ZM6.66667 6.63883V18.8855C6.66668 19.7634 6.88343 20.6278 7.29768 21.4019C7.71193 22.176 8.31087 22.8358 9.04133 23.3228L16 27.9628L22.9587 23.3228C23.6889 22.8359 24.2878 22.1763 24.702 21.4025C25.1162 20.6286 25.3331 19.7646 25.3333 18.8868V6.63883L16 4.56683L6.66667 6.63883ZM14.6667 13.8335V9.8335H17.3333V13.8335H21.3333V16.5002H17.3333V20.5002H14.6667V16.5002H10.6667V13.8335H14.6667Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_56_1391"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtection);
export default __webpack_public_path__ + "static/media/Protection.b7868bfba1df05dcd845ec73bf1c77af.svg";
export { ForwardRef as ReactComponent };